export default __webpack_public_path__ + "static/media/lock_profile.35500445.svg";